import React, {Component} from 'react';
import Reveal from 'react-reveal';
class Featuresitems extends Component{
    render(){
        var {rowClass, fimage, ftitle, descriptions, aClass, number } = this.props;
        return(
            <div className={`agency_featured_item ${rowClass} `}>
                <div className="col-lg-6">
                   <Reveal effect="fadeInLeft">
                        <div className="agency_featured_img text-right mt_70">
                            <img src={require ("../../img/home4/" + fimage)} alt="" className="agency_img_max"/>
                        </div>
                   </Reveal>
                </div>
                <div className="col-lg-6">
                    <div className={`agency_featured_content wow fadeInLeft ${aClass}`} data-wow-delay="0.6s">
                    <Reveal effect="fadeInRight">
                        <div className="dot"><span className="dot1"></span><span className="dot2"></span></div>
                        <h4 className="number">{number}</h4><h4>{ftitle}</h4>
                        <p>{descriptions}</p>
                    </Reveal>
                    </div>
                </div>
            </div>
        )
    }
}

export default Featuresitems;